import jot from './jot'

export const INITIAL_STATE = {
    document: {
        properties: {
            'itinTitle': '',
            'tripTitle': '',
            'itineraryGuid': '',
            'tripGuid': '',
            'totalDays': 1,
            'origination': '',
            'return': '',
            'arrivalDate': '',
            'departureDate': '',
            'initStep': null
        },
        travelers: [],
        legs: [],
        transportation: [],
        basket: null,
        purchaseHistory: null,
        bookingTravelers: null,
    },
    uiState: {
        'sidebarActive': false,
        'bookingActive': false,
        'activeMenuItem': '',
        'activeLeg': null,
        'activeAccommodation': null,
        'activeAccommodationId': null,
        'activeActivity': null,
        'activeActivityId': null,
        'activeTravel': null,
        'detailSection': null,
        'detailSubSection': null,
        'detailSubDetail': null,
        'socketLoaded': false
    },
    lunaTrip: {
        'isLunaTrip': false,
        'trip': null,
        'fromLunaTrip': false,
    },
    clonedTrip: {
        'itineraryGuid': '',
        'tripGuid': ''
    },
    chat: [],
    history: [],
    initialData: [],
    socket: {
        awaiting: null,
        buffer: null,
        history: new jot.LIST([]),
        presence: {},
        commitMsg: null
    },
    clientSessionId: null,
    gitHash: null,
    travelerGuid: null,
    currentUser: null,
    revision: 0,
    route: null,
}
